var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-item"},[_c('Checkbox',{on:{"on-change":_vm.auth},model:{value:(_vm.authed),callback:function ($$v) {_vm.authed=$$v},expression:"authed"}},[_c('strong',[_vm._v(_vm._s(_vm.model.item))]),(_vm.model.route)?_c('span',{staticStyle:{"font-size":".8em"}},[_vm._v("("+_vm._s(_vm.model.route)+")")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }